import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlueCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 78,
	height: 79,
	viewBox: "0 0 78 79",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3564 30.5892C16.259 36.5325 18.9924 42.5371 21.5182 48.652C24.9593 56.9832 22.9504 52.3795 26.0673 60.0249C26.828 61.8907 28.1885 67.2705 28.8771 65.3769C36.2649 45.0605 49.3709 26.4108 66.3407 12.5264",
		stroke: "#0161FE",
		strokeWidth: 17.2632,
		strokeLinecap: "round"
	})
});
const ForwardRef = forwardRef(SvgBlueCheck);
export default ForwardRef;
